import { useEffect, useState } from 'react';
import { Icon } from '../../../../layout/Icon.jsx';

const REQUIRED_PHRASE = 'تصفير النظام';

export function ConfirmResetModal({ open, onClose, onConfirm, loading }) {
  const [text, setText] = useState('');

  useEffect(() => {
    if (!open) setText('');
  }, [open]);

  if (!open) return null;
  const armed = text.trim() === REQUIRED_PHRASE;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 grid place-items-center p-4">
      <div className="bg-white rounded-[14px] shadow-pop w-full max-w-[480px] overflow-hidden border-2" style={{ borderColor: '#7C3AED' }}>
        <div className="px-5 py-4 border-b border-line flex items-center justify-between text-white" style={{ background: '#7C3AED' }}>
          <h3 className="font-extrabold text-[15px] m-0">♻️ تصفير النظام بالكامل — لا يمكن التراجع</h3>
          <button type="button" onClick={onClose} disabled={loading} className="text-white/80 hover:text-white">
            <Icon name="x" size={18} />
          </button>
        </div>

        <div className="p-5">
          <p className="text-[13px] text-ink leading-relaxed mb-3 font-semibold">
            هذه عملية تدميرية شاملة تُعيد النظام لوضع البداية.
          </p>
          <p className="text-[12.5px] text-ink-2 leading-relaxed mb-3">
            سيتم حذف: كل البيانات التشغيلية (الأطفال، أولياء الأمور، الكروت، الجلسات،
            المنتجات، الفواتير، المصاريف، حركات المخزون، الأجهزة)، و<b>كل المستخدمين عدا حساب المدير الرئيسي</b>.
          </p>
          <p className="text-[12.5px] text-ink-2 leading-relaxed mb-4">
            سيُبقى: حساب المدير الرئيسي فقط، الأدوار والصلاحيات، القاصات (برصيد صفر)،
            قواعد التسعير، والإعدادات العامة (اللوقو). وستُعاد كلمة مرور المدير إلى
            <span className="font-mono bg-violet-100 text-violet-700 px-1.5 py-0.5 rounded mx-1">admin123</span>
            وسيتم تسجيل خروجك تلقائياً.
          </p>

          <label className="block text-[12.5px] font-semibold mb-1.5">
            للتأكيد، اكتب <span className="font-mono bg-violet-100 text-violet-700 px-1.5 py-0.5 rounded">{REQUIRED_PHRASE}</span> في المربع أدناه:
          </label>
          <input
            type="text"
            className="input text-[14px] font-mono"
            placeholder={REQUIRED_PHRASE}
            value={text}
            onChange={(e) => setText(e.target.value)}
            disabled={loading}
            autoFocus
          />
        </div>

        <div className="px-5 py-3 border-t border-line flex items-center justify-end gap-2 bg-paper-2">
          <button type="button" className="btn" onClick={onClose} disabled={loading}>
            إلغاء
          </button>
          <button
            type="button"
            className="btn text-white"
            style={{ background: '#7C3AED', opacity: !armed || loading ? 0.5 : 1 }}
            onClick={onConfirm}
            disabled={!armed || loading}
          >
            {loading ? 'جاري التصفير…' : 'تأكيد التصفير النهائي'}
          </button>
        </div>
      </div>
    </div>
  );
}
